import { Box, Typography } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';
import { formatCurrency } from '../../utils/Currency';
import { sharedColors, sharedStyles } from '../../utils/Style';
import { useThemeColor } from '../../hooks/useThemeColor';

type PriceColumnProps = {
  value: number;
  specialValue?: number;
  hasOffer?: boolean;
  hasAtCheckoutDiscount?: boolean;
};

export const PriceColumn = (props: PriceColumnProps) => {
  const { primary } = useThemeColor();

  const prices = [formatCurrency(props.value)];
  if (
    Number.isFinite(props.specialValue) &&
    props.value !== props.specialValue
  ) {
    prices.push(formatCurrency(props.specialValue!));
  }
  prices.reverse();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1.5 }}>
      {prices.length > 1 && (
        <Typography
          sx={{
            ...sharedStyles.tableStringField,
            textDecoration: 'line-through',
            color: sharedColors.statusRed,
          }}
        >
          {prices[1]}
        </Typography>
      )}
      <Typography sx={sharedStyles.tableStringField}>{prices[0]}</Typography>

      {props.hasOffer && <LocalOfferIcon sx={{ color: primary }} />}
      {props.hasAtCheckoutDiscount && (
        <OfflineBoltIcon sx={{ color: primary }} />
      )}
    </Box>
  );
};
